import { render, staticRenderFns } from "./ChatTopbar.vue?vue&type=template&id=0da48f04"
import script from "./ChatTopbar.vue?vue&type=script&lang=js"
export * from "./ChatTopbar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports